import { styled, Typography, css } from '@mui/material';
import { palette } from 'assets/styles/colors';
import { theme } from 'assets/themes/zizzi';
import QRButton from 'components/QRButton';

const profileBackgroundColour = palette.blue[500];
const circleSize = 10;

const whiteCircle = css`
  background-color: ${theme.palette.white};
  height: ${circleSize * 2}px;
  width: ${circleSize}px;
  display: inline-block;
  content: '';
  position: absolute;
  transform: translateY(-50%);
  top: 50%;
`;

const leftCircle = css`
  border-bottom-right-radius: ${circleSize * 2}px;
  border-top-right-radius: ${circleSize * 2}px;
  left: -1px;
`;

const rightCircle = css`
  border-bottom-left-radius: ${circleSize * 2}px;
  border-top-left-radius: ${circleSize * 2}px;
  right: -1px;
`;

export const Wrapper = styled('div')`
  background: ${profileBackgroundColour};
  border-radius: ${theme.radius?.md};
  color: white;
  display: flex;
  flex-direction: column;
  padding: ${theme.spacing(2)} ${theme.spacing(3)};
  position: relative;

  ${theme.breakpoints.up('md')} {
    border-radius: ${theme.radius?.lg};
  }

  &:before {
    ${whiteCircle}
    ${leftCircle}
  }

  &:after {
    ${whiteCircle}
    ${rightCircle}
  }
`;

export const Subtitle = styled(Typography)`
  margin-bottom: 0.8rem;
`;

export const Text = styled(Typography)``;

export const StyledQRButton = styled(QRButton)`
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
`;
